import * as ReselectModule from "reselect";
import { IGroupListState } from ".";
import { IApplicationState } from "..";

export const selectGroupList: ReselectModule.Selector<
  IApplicationState,
  IGroupListState
> = (state) => state.groupList;
